<p-toast></p-toast>

<driver-order-detail *ngIf="showDetailOrderSideBar" [_orderId]="orderId"
                     (changedVisibleDisplayOrderDetailEmit)="changedShowDetailOrderSideBarEmit($event)"
                     [_isVisibleDisplayOrderDetail]="showDetailOrderSideBar"></driver-order-detail>

<p-sidebar [(visible)]="showTransactionsSidebar" position="right" [baseZIndex]="10000"
           (onHide)="cancel()"
           [style]="{width:'800px'}">
    <ng-template pTemplate="header">TX ID: {{transaction.Id}}</ng-template>

    <div *ngIf="loading" style="text-align: center; padding: 30px;">
        <p-progressSpinner [style]="{width: '40px', height: '40px'}" styleClass="custom-spinner" strokeWidth="5"
                           fill="var(--surface-ground)" animationDuration="1s"></p-progressSpinner>
    </div>
    <!--Menu-->

    <p-tabMenu [model]="menuItems" [activeItem]="menuItems[0]"></p-tabMenu>

    <div *ngIf="!loading" class="transaction-body">
        <p-scrollPanel [style]="{width:'100%', height: '100%'}"
                       [styleClass]="'app-scrollpanel'">
            <div class="transaction-info-body" *ngIf="activeTab===transactionDetailsTab.Order">
                <div class="transaction-info-label-group">Xpress Transaction</div>
                <div class="flex transaction-info-block">
                    <div>
                        <div class="flex transaction-info-item">
                            <div class="transaction-info-item-label od-name">
                                Transaction date:
                            </div>
                            <div class="transaction-info-item-value od-value">
                                {{transaction.CreatedAtDate}}
                            </div>
                        </div>
                        <div class="flex">
                            <div class="transaction-info-item-label od-name">
                                Transaction type:
                            </div>
                            <div class="transaction-info-item-value od-value">
                                {{transaction.TransactionTypeText}}
                            </div>
                        </div>
                    </div>
                    <div>
                        <div class="flex">
                            <div class="transaction-info-item-label od-name">
                                Transaction time:
                            </div>
                            <div class="transaction-info-item-value od-value">
                                {{transaction.CreatedAtTime}}
                            </div>
                        </div>
                    </div>
                </div>

                <div class="transaction-info-label-group">Customer Promotions</div>
                <div class="flex transaction-info-block">
                    <div>
                        <div class="flex transaction-info-item">
                            <div class="transaction-info-item-label od-name">
                                Promo used?:
                            </div>
                            <div class="transaction-info-item-value od-value">
                                {{transaction.Promo ? 'Yes' : 'No'}}
                            </div>
                        </div>
                        <div class="flex">
                            <div class="transaction-info-item-label od-name">
                                Promo amount:
                            </div>
                            <div class="transaction-info-item-value od-value" *ngIf="transaction.Promo && transaction.Promo.UsePercent !== 0">
                                {{transaction.Promo.UsePercent}} %
                            </div>
                            <div class="transaction-info-item-value od-value" *ngIf="transaction.Promo && transaction.Promo.UseAmount !== 0">
                                &#8369; {{transaction.Promo.UseAmount}}
                            </div>
                            <div class="transaction-info-item-value od-value" *ngIf="transaction.Promo && transaction.Promo.UseAmount === 0 && transaction.Promo.UsePercent !== 0">
                                0
                            </div>
                            <div class="transaction-info-item-value od-value" *ngIf="!transaction.Promo">
                                N/A
                            </div>
                        </div>
                    </div>
                    <div>
                        <div class="flex transaction-info-item">
                            <div class="transaction-info-item-label od-name">
                                Promo:
                            </div>
                            <div class="transaction-info-item-value od-value">
                                {{(transaction.Promo) ? transaction.Promo.Code : 'N/A'}}
                            </div>
                        </div>
                        <div class="flex">
                            <div class="transaction-info-item-label od-name">
                                Promo funding:
                            </div>
                            <div class="transaction-info-item-value od-value">
                                {{(transaction.Promo) ? 'Xpress' : 'N/A'}}
                            </div>
                        </div>
                    </div>
                </div>

                <div class="transaction-info-label-group">Payment</div>
                <div class="flex transaction-info-block">
                    <div>
                        <div class="flex transaction-info-item">
                            <div class="transaction-info-item-label od-name">
                                Payment Method:
                            </div>
                            <div class="transaction-info-item-value od-value">
                                {{transaction.PaymentMIDPayServiceText}}
                            </div>
                        </div>
                        <div class="flex">
                            <div class="transaction-info-item-label od-name">
                                Transaction amount:
                            </div>
                            <div class="transaction-info-item-value od-value">
                                &#8369; {{transaction.TransactionAmount}}
                            </div>
                        </div>
                    </div>
                    <div>
                        <div class="flex transaction-info-item">
                            <div class="transaction-info-item-label od-name">
                                Partner TX ID:
                            </div>
                            <div class="od-value">
                                <span class="transaction-value-link">{{transaction.PartnerTXID}}</span>
                            </div>
                        </div>
                        <div class="flex">
                            <div class="transaction-info-item-label od-name">
                                Transaction Status:
                            </div>
                            <div class="transaction-info-item-value od-value">
                                <span *ngIf="transaction.TransactionStatus === 'PAID'" class="transaction-color-green">Success</span>
                                <span *ngIf="transaction.TransactionStatus !== 'PAID'" class="transaction-color-red">{{transaction.TransactionStatus}}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="transaction-info-label-group">Products & Services</div>
                <div class="flex transaction-info-block">
                    <div class="flex">
                        <div class="transaction-info-item-label od-name">
                            Service:
                        </div>
                        <div class="transaction-info-item-value od-value">
                            {{transaction.DeliveryServiceTypeText}} | {{transaction.DeliveryVehicleTypeText}}
                        </div>
                    </div>
                    <div class="flex">
                        <div class="transaction-info-item-label od-name">
                            Products:
                        </div>
                        <div class="transaction-info-item-value od-value">
                            N/A
                        </div>
                    </div>
                </div>

                <div class="transaction-info-label-group">Corresponding Identifiers</div>
                <div class="transaction-info-block">
                    <div class="flex transaction-info-item">
                        <div class="transaction-info-item-label od-name">
                            Booking ID:
                        </div>
                        <div *ngIf="orderStats" class="transaction-info-item-value od-value">
                            <span class="transaction-value-link"
                                  (click)="openActiveOrderDetail(orderStats?.XpressDeliveryOrderId)"
                                  *ngIf="orderStats?.XpressDeliveryOrderId">
                                {{orderStats?.XpressDeliveryOrderId}}
                            </span>
                            <span class="transaction-info-item-value od-value"
                                  *ngIf="orderStats?.XpressDeliveryOrderId">
                                -
                            </span>
                        </div>
                    </div>
                    <div class="flex">
                        <div class="transaction-info-item-label od-name">
                            Order ID:
                        </div>
                        <div class="transaction-info-item-value od-value">
                            {{ orderStats?.LokalOrderId ? orderStats.LokalOrderId : '-' }}
                        </div>
                    </div>
                </div>


                <div class="transaction-info-label-group">Booking Details</div>
                <div class="transaction-info-block">
                    <div class="flex transaction-info-item">
                        <div class="transaction-info-item-label od-name">
                            Pick-up Location
                        </div>
                        <div class="transaction-info-item-value od-value">
                            {{(transaction.PickupBuildingName) ? transaction.PickupBuildingName : '-'}}
                            <br />
                            <span class="transaction-value-address">{{transaction.PickupAddress}}</span>
                        </div>
                    </div>
                    <div class="flex">
                        <div class="transaction-info-item-label od-name">
                            Drop off Location
                        </div>
                        <div class="transaction-info-item-value od-value">
                            {{(transaction.DropOffBuildingName) ? transaction.DropOffBuildingName : '-'}}
                            <br />
                            <span class="transaction-value-address">{{transaction.DropOffAddress}}</span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="transaction-info-body" *ngIf="activeTab===transactionDetailsTab.Driver">
                <div *ngIf="orderStats.XpressRider">
                    <div class="flex flex-row" style="align-items: center;">
                        <div style="margin-right: 30px;" class="driver-info-img">
                            <img style="border: 2px solid #004060" *ngIf="orderStats.XpressRider.ImageUrl; else placeholder"
                                 src="{{orderStats.XpressRider.ImageUrl}}" />
                            <ng-template #placeholder>
                                <img style="border: 2px solid #004060" src="/XpressApp/assets/images/avatar_placeholder.svg" />
                            </ng-template>
                        </div>
                        <div>
                            <div class="flex flex-row transaction-info-item">
                                <div class="od-name">Full Name</div>
                                <div class="od-value">{{orderStats.XpressRider.FullName}}</div>
                            </div>
                            <div class="flex flex-row transaction-info-item">
                                <div class="od-name">Gender</div>
                                <div class="od-value">{{orderStats.XpressRider.GenderStr}}</div>
                            </div>
                            <div class="flex flex-row transaction-info-item">
                                <div class="od-name">Phone</div>
                                <div class="od-value">{{orderStats.XpressRider.Phone}}</div>
                            </div>
                            <div class="flex flex-row transaction-info-item">
                                <div class="od-name">Email</div>
                                <div class="od-value">{{ orderStats.XpressRider.Email || 'N/A' }}</div>
                            </div>
                            <div class="flex flex-row transaction-info-item">
                                <div class="od-name">Date of birth</div>
                                <div class="od-value">{{ orderStats.XpressRider.BirthDate || 'N/A' }}</div>
                            </div>
                            <div class="flex flex-row transaction-info-item">
                                <div class="od-name">Full profile</div>
                                <div class="od-value ui-resizable-column__link-id" (click)="visibleDriverDetail=true">View</div>
                            </div>
                        </div>
                    </div>
                    <hr class="hr-filter" style="margin: 50px 0px" />
                </div>
                <div *ngIf="!orderStats.XpressRider">
                    <img src="../Content/xpress-app/images/person_not_found.svg" style="display: block; margin: auto auto;" />
                    <div style="text-align: center; font-size: 18px;" class="od-value">This Transaction is not related to driver</div>
                </div>
            </div>

            <div class="transaction-info-body" *ngIf="activeTab===transactionDetailsTab.Customer">
                <div class="flex flex-row align-items-center customer-container">
                    <div style="margin-right: 30px;" class="driver-info-img">
                        <img class="driver-info-img-border" *ngIf="orderStats?.Customer?.ImageUrl; else placeholder"
                             src="{{orderStats.Customer.ImageUrl}}" />
                        <ng-template #placeholder>
                            <img class="driver-info-img-border" src="/XpressApp/assets/images/avatar_placeholder.svg" />
                        </ng-template>
                    </div>
                    <div class="flex flex-row">
                        <div>
                            <div class="flex flex-row transaction-info-item">
                                <div class="od-name">Name</div>
                                <div class="od-value">{{orderStats?.Customer?.UserName}}</div>
                            </div>
                            <div class="flex flex-row transaction-info-item">
                                <div class="od-name">Sign up:</div>
                                <div class="od-value">{{orderStats?.Customer?.SignupDate}}</div>
                                <span style="margin-left: 7px;">({{orderStats?.Customer?.SignUpDaysLeft}} days)</span>
                            </div>
                            <div class="flex flex-row transaction-info-item">
                                <div class="od-name">Phone</div>
                                <div class="od-value">{{orderStats?.Customer?.Phone}}</div>
                            </div>
                            <div class="flex flex-row transaction-info-item">
                                <div class="od-name">Rating</div>
                                <div class="od-value">★{{orderStats?.Customer?.Rating}}</div>
                            </div>
                            <div class="flex flex-row transaction-info-item">
                                <div class="od-name">Account</div>
                                <div class="od-value">N/A</div>
                            </div>
                        </div>
                        <div class="ml-7">
                            <div class="flex flex-row transaction-info-item">
                                <div class="od-name">Bookings:</div>
                                <div class="od-value">{{customerStats?.TotalOrdersCount}}</div>
                            </div>
                            <div class="flex flex-row transaction-info-item">
                                <div class="od-name">Completed:</div>
                                <div class="od-value">{{customerStats?.CompletedOrdersCount}} ({{customerStats?.CompletedOrdersPercent}}%)</div>
                            </div>
                            <div class="flex flex-row transaction-info-item">
                                <div class="od-name">Spend:</div>
                                <div class="od-value">&#8369; {{customerStats?.TotalOrdersAmount}}</div>
                            </div>
                            <div class="flex flex-row transaction-info-item">
                                <div class="od-name">Priority:</div>
                                <div class="od-value">{{transaction?.IsPriority ? 'Priority' : 'No'}}</div>
                            </div>
                            <div class="flex flex-row transaction-info-item">
                                <div class="od-name">Rating</div>
                                <div class="od-value">{{orderStats?.Customer?.Rating > 3.5 ? 'Positive' : 'Negative'}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="transaction-info-body" *ngIf="activeTab===transactionDetailsTab.Merchant">
                <div style="display: block; margin: 15vh auto;" *ngIf="!orderStats.Store">
                    <img src="../Content/xpress-app/images/person_not_found.svg" style="display: block; margin: auto auto;" />
                    <div style="text-align: center; font-size: 18px;" class="od-value">This Transaction is not related to merchants</div>
                </div>

                <div *ngIf="orderStats.Store">
                    <div class="flex flex-row">
                        <div style="margin-right: 30px;">
                            <div class="od-user-img">
                                <img src="https://xpressstoragedev.blob.core.windows.net/images/64f9b90d-2994-423f-9321-2b37b84811f0" />
                            </div>
                        </div>
                        <div>
                            <div class="flex flex-row transaction-info-item">
                                <div class="od-name">Store Name</div>
                                <div class="od-value">{{orderStats.Store.Name}}</div>
                            </div>
                            <div class="flex flex-row transaction-info-item">
                                <div class="od-name">Location</div>
                                <div class="od-value">{{orderStats.Store.Address}}</div>
                            </div>
                            <div class="flex flex-row transaction-info-item">
                                <div class="od-name">Phone</div>
                                <div class="od-value">{{orderStats.Store.Phone}}</div>
                            </div>
                            <div class="flex flex-row transaction-info-item">
                                <div class="od-name">Full Profile</div>
                                <div class="od-value ui-resizable-column__link-id">View</div>
                            </div>
                        </div>
                    </div>
                    <hr class="hr-filter" style="margin: 50px 0px" />

                    <div>
                        <div class="flex flex-row transaction-info-item">
                            <div class="od-name">Priority:</div>
                            <div class="od-value">{{transaction.IsPriority ? 'Priority' : 'No'}}</div>
                        </div>
                        <div class="flex flex-row transaction-info-item">
                            <div class="od-name">Session Time:</div>
                            <div class="od-value">{{orderStats.SessionTime}}</div>
                        </div>
                        <div class="flex flex-row transaction-info-item">
                            <div class="od-name">Attempts</div>
                            <div>
                                <div class="od-value" style="margin-bottom: 18px;">{{orderStats.AttemptsCount}}</div>
                                <div class="flex flex-row" *ngFor="let item of orderStats.RiderActions">
                                    <div class="transaction-info-attempts-field">{{item.CreatedAt}}</div>
                                    <div class="transaction-info-attempts-field">{{item.VehicleTypeStr}}</div>
                                    <div>{{item.RiderAction}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="transaction-info-body" *ngIf="activeTab === transactionDetailsTab.Messages">
                <div class="transaction-info-label-group">Driver and Customer Messages</div>
                <div *ngFor="let item of orderStats.Messages">
                    <div class="order-detail-block-message-rider"
                         *ngIf="item.MessageTypeId === chatMessageType.RiderToCustomer || item.MessageTypeId === chatMessageType.MerchantToCustomer">
                        <div class="w-70">
                            <div class="message-author">{{item.RiderUserName}}</div>
                            <div class="order-detail-chat-message-rider message-text-left">{{item.Message}}</div>
                            <div class="message-date flex justify-content-end">{{item.CreatedAt}}</div>
                        </div>
                    </div>

                    <div class="order-detail-block-message-passenger"
                         *ngIf="item.MessageTypeId === chatMessageType.CustomerToRider || item.MessageTypeId === chatMessageType.CustomerToMerchant">
                        <div class="w-70">
                            <div class="message-author flex justify-content-end">{{item.UserName}}</div>
                            <div class="order-detail-chat-message-passenger message-text-right">{{item.Message}}</div>
                            <div class="message-date">{{item.CreatedAt}}</div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="transaction-info-body" *ngIf="activeTab===transactionDetailsTab.Timeline">
                <div class="transaction-info-label-group">Order Timeline</div>
                <div *ngIf="appData.isBoracayLocation">
                    <div class="od-value">Order Processing</div>
                    <div class="flex flex-row flex-wrap">
                        <div class="pft-column-50">
                            <div class="flex flex-row flex-wrap mt-3">
                                <div class="pft-column-50 p-1 pft-label">
                                    Time accepted:
                                </div>
                                <div class="pft-column-50 p-1">
                                    <span class="pft-value">{{orderStats.CreatedAt}}</span>
                                </div>
                                <div class="pft-column-50 p-1 pft-label">
                                    Start packing:
                                </div>
                                <div class="pft-column-50 p-1">
                                    <span class="pft-value">{{orderStats.PackingStartedAt}}</span>
                                </div>
                                <div class="pft-column-50 p-1 pft-label">
                                    Finished packing:
                                </div>
                                <div class="pft-column-50 p-1">
                                    <span class="pft-value">{{orderStats.ReadyToDispatchAt}}</span>
                                </div>
                                <div class="pft-column-50 p-1 pft-label">
                                    Dispatch:
                                </div>
                                <div class="pft-column-50 p-1">
                                    <span class="pft-value">{{orderStats.DispatchAt}}</span>
                                </div>
                                <div class="pft-column-50 p-1 pft-label">
                                    Delivered:
                                </div>
                                <div class="pft-column-50 p-1">
                                    <span class="pft-value">{{orderStats.CompletedAt}}</span>
                                </div>
                                <div class="pft-column-50 p-1 pft-label" *ngIf="orderStats.CanceledAt">
                                    Canceled:
                                </div>
                                <div class="pft-column-50 p-1" *ngIf="orderStats.CanceledAt">
                                    <span class="pft-value">{{orderStats.CanceledAt}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div *ngIf="!appData.isBoracayLocation && orderStats.XpressOrderId">
                    <div class="od-value">Order Processing</div>
                    <div class="flex flex-row flex-wrap">
                        <div class="pft-column-50">
                            <div class="flex flex-row flex-wrap mt-3">
                                <div class="pft-column-50 p-1 pft-label">
                                    Time accepted:
                                </div>
                                <div class="pft-column-50 p-1">
                                    <span class="pft-value">{{orderStats.RiderAssignedTime}}</span>
                                </div>
                                <div class="pft-column-50 p-1 pft-label mb-3">
                                    Time Arrival on Pick up point:
                                </div>
                                <div class="pft-column-50 p-1 mb-3">
                                    <span class="pft-value">{{orderStats.ArrivedToPickupTime}}</span>
                                </div>
                                <ng-container *ngFor="let dropoff of orderStats.RiderDropoffActions; let i = index;">
                                    <div class="pft-column-50 p-1 pft-label">
                                        Time of Drop off #{{i+1}}:
                                    </div>
                                    <div class="pft-column-50 p-1">
                                        <span class="pft-value">{{dropoff.CreatedTime}}</span>
                                    </div>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                </div>

                <div *ngIf="!appData.isBoracayLocation && orderStats.LokalOrderId">
                    <div class="flex flex-row flex-wrap mt-3">
                        <div class="pft-column-50">
                            <div class="flex flex-row flex-wrap">
                                <div class="pft-column-50 p-1 pft-label">
                                    Priority:
                                </div>
                                <div class="pft-column-50 p-1">
                                    <span class="pft-value">Priority</span>
                                </div>

                                <div class="pft-column-50 p-1 pft-label">
                                    Session time:
                                </div>
                                <div class="pft-column-50 p-1">
                                    <span class="pft-value">{{orderStats.SessionTime}}</span>
                                </div>

                                <div class="pft-column-50 p-1 pft-label">
                                    Attempts:
                                </div>
                                <div class="pft-column-50 p-1">
                                    <span class="pft-value">{{orderStats.AttemptsCount}}</span>
                                </div>
                            </div>
                        </div>

                        <div class="pft-column-50">
                            <ul class="vertical-list">
                                <li class="vertical-list-item">
                                    <div class="flex justify-content-between">
                                        <div>Time Accepted</div>
                                        <div>{{orderStats.AcceptedTime}}</div>
                                    </div>
                                </li>
                                <li class="vertical-list-item">
                                    <div class="flex justify-content-between">
                                        <div>Time Arrival on Pick up point</div>
                                        <div>{{orderStats.DispatchTime}}</div>
                                    </div>
                                </li>
                                <li class="vertical-list-item">
                                    <div class="flex justify-content-between">
                                        <div>Time Arrival on Drop off</div>
                                        <div>{{orderStats.DeliveredTime}}</div>
                                    </div>
                                </li>
                                <li class="vertical-list-item">
                                    <div class="flex justify-content-between">
                                        <div>Time of Drop off</div>
                                        <div>{{orderStats.CompletedTime}}</div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <hr />
                    <div class="transaction-info-label-group">Rider Details</div>
                    <div id='map' style='width: 100%; height: 300px;'></div>
                    <div class="flex flex-row mt-3">
                        <div class="vertical-dotted-line">
                            <img src="/XpressApp/assets/images/live-map-icons/pickup.svg" />
                            <img src="/XpressApp/assets/images/live-map-icons/destination.svg" />
                        </div>
                        <div class="ml-2">
                            <div class="rider-dialog-destination">Pick Up</div>
                            <div class="rider-dialog-destination-buildingname">{{orderStats.UserAddress.Address}}</div>

                            <div class="rider-dialog-destination mt-3">Destination</div>
                            <div class="rider-dialog-destination-buildingname">{{orderStats.Store.Address}}</div>
                        </div>
                    </div>
                </div>
            </div>

        </p-scrollPanel>

        <hr class="transaction-line" *ngIf="activeTab === transactionDetailsTab.Order" />

        <div class="flex justify-content-end" *ngIf="activeTab === transactionDetailsTab.Order">
            <anti-fraud-actions class="mr-2"
                                [transactionId]="transactionId"
                                [transactionStatus]="transaction.TransactionStatus"
                                [isPaid]="transaction.IsPaid"
                                [isVoided]="transaction.IsVoided"
                                (actionCompleted)="onAntiFraudActionCompleted()">
            </anti-fraud-actions>

            <div *ngIf="hasAccessToRefund">
                <button pButton pRipple
                        type="button"
                        label="Refund"
                        class="p-button btn-transaction-edit"
                        [disabled]="!transaction.IsPaid || transaction.IsVoided || isRefundButtonDisabled"
                        (click)="showPopupRefundTransaction()"></button>
                <p *ngIf="transaction.IsVoided">The transaction is already voided.</p>
                <p *ngIf="!transaction.IsPaid">The transaction is not paid.</p>
            </div>
        </div>
    </div>


</p-sidebar>

<driver-detail [_visibleDetail]="visibleDriverDetail" [_driverId]="orderStats.XpressRider.Id" (changedVisibleDetailEmit)="changedVisibleDriverDetailEmit($event)" *ngIf="visibleDriverDetail"></driver-detail>
<customer-info *ngIf="visibleCustomerDetail"
               [isVisibleCustomerInfo]="visibleCustomerDetail"
               [_customerId]="orderStats.Customer.Id"
               [showEditFields]="false"
               (changedVisibleCustomerInfoEmit)="changedVisibleCustomerInfoEmit($event)"></customer-info>

<p-dialog [(visible)]="showDialogRefundTransaction"
          [modal]="true"
          [style]="{width: '630px', height: '660px'}"
          [draggable]="false"
          [resizable]="false">
    <div class="m-0 refund-body">
        <img src="/XpressApp/assets/images/icon_refund.svg" />
        <p class="refund-title">Refund Transaction?</p>
        <p class="refund-description">Are you sure you would like to refund this transaction?</p>
        <div class="refund-textarea-margin">
            <label for="price">Refund Type</label>
            <p-dropdown [options]="refundTypes"
                        [(ngModel)]="selectedRefundType"
                        placeholder="Refund Type"
                        optionLabel="Name"
                        [showClear]="false"></p-dropdown>
        </div>
        <div class="refund-textarea-margin">
            <label for="price">Reason for Refund</label>
            <p-dropdown [options]="refundReasons"
                        [(ngModel)]="selectedRefundReason"
                        placeholder="Reason for Refund"
                        optionLabel="Name"
                        [showClear]="false"></p-dropdown>
        </div>
        <div class="refund-textarea-margin">
            <label for="price">Explanation for refund</label>
            <textarea rows="5"
                      cols="30"
                      class="w-100"
                      style="resize: none;"
                      pInputTextarea
                      placeholder="Explanation for Refund"
                      [(ngModel)]="explanationForRefund"></textarea>
        </div>
        <div class="refund-description-margin">
            <p class="refund-description">All refunds are credited to the Users Xpress Wallet and will reflect within 30min</p>
        </div>
    </div>
    <div class="flex justify-content-end pb-4">
        <div>
            <button pButton pRipple type="button"
                    label="Cancel"
                    (click)="refundTransactionCancel()"
                    class="p-button-text btn-cancel"></button>
        </div>
        <div>
            <button pButton pRipple type="button"
                    label="Refund"
                    [disabled]="selectedRefundType?.id === 0 || selectedRefundReason?.id === 0 || isRefundApplyButtonDisabled"
                    (click)="refundTransactionApply()"
                    class="p-button-danger btn-refund"></button>
        </div>
    </div>
</p-dialog>
